import { EType } from '../../../repositories/journal/entities/page_info/PageInfoSchema';

/** Выбирает правильное название qs-переменной для тэгов */
export const prepareQsTagName = (pageType: EType) => {
  if (pageType === EType.MainPage) {
    return 'with-tag';
  } else if ([EType.News, EType.Articles, EType.Blogs, EType.Questions].includes(pageType)) {
    return 'tag';
  }

  return;
};
